module.exports = __webpack_public_path__ + "static/media/1-4.e4c0b97f.mp3";